import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { alterPlansInComaparePage, resetPlansInComparePage } from '../../modules/comparePageSetRemovePlans';
import WindowEventListener from '../WindowEventListener';


const propTypes = {
  dispatch: PropTypes.func.isRequired,
};

class SetComparePagePlans extends Component {
  receiveMessage = ({ origin, data: { type, payload } }) => {
    const { dispatch } = this.props;
    const matchURL = /https?:\/\/+([a-z])*\.*([a-z])*\.*(isf)+\.*[io]*(com)*/;

    if (type === 'COMPARE_PAGE_ALTER_PLANS') {
      if (origin.match(matchURL) && payload) {
        dispatch(alterPlansInComaparePage(payload));
      }
    }

    if (type === 'COMPARE_PAGE_RESET_PLANS') {
      if (origin.match(matchURL)) {
        dispatch(resetPlansInComparePage());
      }
    }
  }

  render() {
    return <WindowEventListener event="message" onEvent={this.receiveMessage} />;
  }
}

SetComparePagePlans.propTypes = propTypes;

export default connect()(SetComparePagePlans);
